module.exports = __webpack_public_path__ + "img/joimax_Logo_Endoscopic-Spine-Experts.39dedd38.png";